
export const SHAMIR_RX_SURCHARGE_DEFAULTS = {
    AN: 'Barwienie pełne',
    AO: 20,
    AP: 20,
    AQ: 45,
    AR: 8,
    AS: 'Filtr',
    AT: 45,
    AU: 45,
    AV: 89,
    AW: 8,
    AX: 'Barwienie gradalne',
    AY: 24,
    AZ: 24,
    BA: 55,
    BB: 8,
    BC: 'Barwienie według wzoru',
    BD: 41,
    BE: 41,
    BF: 88,
    BG: 8,
};
